module.exports = __webpack_public_path__ + "img/lightning.dae233b5.png";